module.exports = __webpack_public_path__ + "static/media/portal-logo2.4f912cec.svg";